import { FC, PropsWithChildren } from 'react';
import cx from 'classnames';
import styles from './header-search-bar-suggestions-column.module.scss';

type HeaderSearchBarSuggestionsColumnProps = {
  className?: string;
};

export const HeaderSearchBarSuggestionsColumn: FC<
  PropsWithChildren<HeaderSearchBarSuggestionsColumnProps>
> = ({ children, className }) => (
  <div
    className={cx(
      styles['header-search-bar-suggestions-column'],
      className ? className : ''
    )}
  >
    {children}
  </div>
);
